import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

const RANKS = [
  { key: "estudiante_de_medicina", name: "Estudiante de Medicina", points: 0 },
  { key: "interno_de_pregrado", name: "Interno de Pregrado", points: 200 },
  { key: "medico_pasante", name: "Médico Pasante de Servicio Social", points: 600 },
  { key: "medico_general", name: "Médico General", points: 1200 },
  { key: "residente_primer_ano", name: "Residente de Primer Año", points: 2000 },
  { key: "residente_ultimo_ano", name: "Residente de Último Año", points: 3200 },
  { key: "jefe_de_residentes", name: "Jefe de Residentes", points: 5000 },
  { key: "medico_especialista", name: "Médico Especialista", points: 8000 },
  { key: "subespecialista", name: "Subespecialista", points: 14000 },
  { key: "alta_especialidad", name: "Alta Especialidad", points: 30000 },
  { key: "maestria_ciencias", name: "Maestría en Ciencias Médicas", points: 50000 },
  { key: "doctorado_ciencias", name: "Doctorado en Ciencias Médicas", points: 80000 },
  { key: "jefe_de_servicio", name: "Jefe de Servicio", points: 120000 },
  { key: "director_hospital", name: "Director de Hospital", points: 180000 },
  { key: "secretario_salud", name: "Secretario de Salud", points: 260000 },
  { key: "director_oms", name: "Director General de la OMS", points: 400000 },
  { key: "premio_nobel", name: "Premio Nobel de Medicina", points: 700000 },
];

const CaminoDelMedico = ({ user }) => {
  const [pointsData, setPointsData] = useState(null);

  useEffect(() => {
    const fetchPoints = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API_BASE_URL}/api/points/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setPointsData(res.data);
      } catch (err) {
        console.error('Error fetching points:', err);
      }
    };
    fetchPoints();
    const interval = setInterval(fetchPoints, 60000);
    return () => clearInterval(interval);
  }, []);

  if (!pointsData) return null;

  const { total_points, current_rank, next_rank } = pointsData;
  const gender = user?.gender || 'male';
  const spriteUrl = `/sprites/${current_rank.key}_${gender}.png?v=3`;

  const currentRankPoints = current_rank.points;
  const nextRankPoints = next_rank ? next_rank.points : current_rank.points;
  const pointsInLevel = total_points - currentRankPoints;
  const levelRange = nextRankPoints - currentRankPoints;
  const progressPercent = next_rank 
    ? Math.min((pointsInLevel / levelRange) * 100, 100)
    : 100;

  return (
    <div className="w-full flex flex-col items-center" data-testid="camino-del-medico" style={{ fontFamily: "'Nunito', sans-serif" }}>
      {/* Character sprite - explicitly centered */}
      <div className="w-full flex justify-center">
        <img
          src={spriteUrl}
          alt={current_rank.name}
          className="drop-shadow-lg w-[120px] h-[140px] md:w-[168px] md:h-[192px] block mx-auto"
          style={{ 
            objectFit: 'contain',
            objectPosition: 'center center',
            imageRendering: 'auto'
          }}
          data-testid="character-sprite"
        />
      </div>

      {/* Rank name and progress text */}
      <div className="mt-2 text-center" data-testid="rank-info">
        <p className="font-extrabold text-base text-gray-800">
          <span className="text-gray-500 font-bold">Rango: </span>{current_rank.name}
        </p>
        <p className="text-sm text-gray-500 font-semibold">
          Progreso: <span className="font-extrabold text-gray-800">{total_points.toLocaleString()}</span>
          {next_rank && (
            <> / {next_rank.points.toLocaleString()} pts</>
          )}
          {!next_rank && <> pts - ¡Rango máximo!</>}
        </p>
      </div>

      {/* XP bar - gray, static fill, explicitly centered */}
      <div className="mt-2 w-full max-w-md mx-auto h-6 bg-gray-100 rounded-full overflow-hidden border border-gray-200 relative">
        <div
          className="h-full rounded-full"
          style={{ 
            width: `${Math.max(progressPercent, 2)}%`,
            background: 'linear-gradient(90deg, #a0a0a0, #707070, #505050)'
          }}
        ></div>
        <span className="absolute inset-0 flex items-center justify-center text-xs font-bold text-gray-600">
          {Math.round(progressPercent)}%
        </span>
      </div>
    </div>
  );
};

export default CaminoDelMedico;
